import AdminTool from './admin-tool'

export default AdminTool
